import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient, HttpHeaders, HttpResponse, HttpHandler } from '@angular/common/http';
import { AppRoutingModule } from './app.routing.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxTwitterTimelineModule } from 'ngx-twitter-timeline';
// import { NgxMaskModule, IConfig } from 'ngx-mask'

import { MatSliderModule } from '@angular/material/slider';

import { MyDatePickerModule } from 'mydatepicker';

import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth.guard';

import { ModalService } from './shared/modal/modal.service';
import { SnackBarService } from './shared/snackbar/snackbar.service';
import { AdvisorBarService } from './shared/advisor-bar/advisor-bar.service';
import { UserService } from './services/user.service';
import { SidebarService } from './services/sidebar.service';

import { GlobalService } from './services/global.service';
import { OrganizationService } from './services/organization.service';
import { PagerService } from './services/pager.service';
import { MenuService } from './services/menu.service';
import { LoadingService } from './shared/loading/loading.service';
import { ClientService } from './create-client/client.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { SidebarClientComponent } from './shared/sidebar-client/sidebar-client.component';
import { SidebarClientEditComponent } from './shared/sidebar-client-edit/sidebar-client-edit.component';
import { PublicSidebarComponent } from './shared/public-sidebar/public-sidebar.component';
import { PublicHeaderComponent } from './shared/public-header/public-header.component';
import { TopnavComponent } from './shared/topnav/topnav.component';
import { ModalComponent } from './shared/modal/modal.component';
import { SnackBarComponent } from './shared/snackbar/snackbar.component';
import { TimeoutComponent } from './shared/timeout/timeout.component';
import { InfoIconComponent } from './shared/info-icon/info-icon.component';
import { NavCardComponent } from './shared/nav-card/nav-card.component';
import { SocialSecurityIllustrationCardComponent } from './shared/social-security-illustration-card/social-security-illustration-card.component';
import { SocialSecurityBenefitCardComponent } from './shared/social-security-benefit-card/social-security-benefit-card.component';
import { LoadingComponent } from './shared/loading/loading.component';
import { AdvisorBarComponent } from './shared/advisor-bar/advisor-bar.component';
import { BreadCrumbComponent } from './shared/breadcrumbs/breadcrumbs.component';

import { AdminComponent } from './admin/admin.component';
import { MetricRectangleComponent } from './shared/metric-rectangle/metric-rectangle.component';
import { AdvisorsComponent } from './advisors/advisors.component';
import { ClientsComponent } from './clients/clients.component';
import { ViewOrganizationsComponent } from './view-organizations/view-organizations.component';
import { SettingsComponent } from './settings/settings.component';
import { AuthWrapperComponent } from './auth-wrapper/auth-wrapper.component';
import { ApplicationsComponent } from './applications/applications.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { InfoCenterComponent } from './info-center/info-center.component';
import { ReportsComponent } from './reports/reports.component';
import { IllustrationsComponent } from './illustrations/illustrations.component';
import { NewIllustrationsComponent } from './new-illustrations/new-illustrations.component';
import { NewIllustrationOptionsComponent } from './new-illustration-options/new-illustration-options.component';
import { LegacyReportsComponent } from './legacy-reports/legacy-reports.component';
import { CreateReportComponent } from './create-report/create-report.component';
import { ViewReportsComponent } from './view-reports/view-reports.component';
import { SocialSecurityComponent } from './social-security/social-security.component';
import { MedicareMeansTestingComponent } from './medicare-means-testing/medicare-means-testing.component';
import { MedicareMeansTestingComponentV2 } from './medicare-means-testing-v2/medicare-means-testing-v2.component';
import { CombinedComponent } from './combined/combined.component';
import { HealthCareComponent } from './healthcare/healthcare.component';
import { LongTermCareComponent } from './long-term-care/long-term-care.component';
import { CombinedHealthCareLTCComponent } from './combined-hc-ltc/combined-hc-ltc.component';
import { LeadsComponent } from './leads/leads.component';
import { MetricsComponentV2 } from './metrics-v2/metrics-v2.component';
import { CreateReportSelectionComponent } from './create-report-selection/create-report-selection.component';
import { MarketingMaterialComponent } from './marketing-material/marketing-material.component';

import { ForgotPasswordComponent } from './forgot-password/forgotpassword.component';
import { ResetPasswordComponent } from './reset-password/resetpassword.component';
import { RegisterComponent } from './register/register.component';
import { SignUpComponent } from './sign-up/sign-up.component';

//recaptcha
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

import { DragAndDropModule } from 'angular-draggable-droppable';

//material
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule, MatButtonToggleModule, MatTooltipModule, MatOptionModule, MatSelectModule, MatDatepickerModule, MatRadioModule } from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule} from '@angular/material/card';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Ng5SliderModule } from 'ng5-slider';
import { DecimalPipe } from '@angular/common';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { CostProjectionDetailsComponent } from './shared/modal/cost-projection-details/cost-projection-details.component';
import { AddCategoryComponent } from './shared/modal/add-category/add-category.component';
import { SupportComponent } from './shared/modal/support/support.component';
import { SupportTicketsComponent } from './support/support-tickets.component';
import { ProfileComponent } from './shared/modal/profile/profile.component';
import { UploadDocumentComponent } from './shared/modal/upload-document/upload-document.component';

import { COLAComponent } from './shared/modal/cola/cola.component';
import { PIAComponent } from './shared/modal/pia-calculator/pia-calculator.component';
import { SubstantialEarningsComponent } from './shared/modal/substantial-earning-years-calculator/substantial-earnings-calculator.component';
import { AdjustDesiredClaimAgeComponent } from './shared/modal/adjust-desired-claim-age/adjust-desired-claim-age.component';
import { FundingSourceComponent } from './shared/modal/funding-source/funding-source.component';
import { CostOfWaitingComponent } from './shared/modal/cost-of-waiting/cost-of-waiting.component';
import { CreateClientComponent } from './create-client/create-client.component';
import { AdjustRatesComponent } from './shared/modal/adjust-rates-of-return/adjust-rates.component';
import { AdjustLongTermCareCost } from './shared/modal/long-term-care-adjust-cost/ltc-adjust-cost.component';
import { MmtMessageComponent } from './shared/modal/mmt-message/mmt-message.component';
import { BasicQuestionComponent } from './shared/modal/basic-question/basic-question.component';
import { ProfileNotEligibleComponent } from './shared/modal/profile-not-eligible/profile-not-eligible.component';

import { NewAddClientComponent } from './new-add-client/new-add-client.component';
import { CreateAdvisorComponent } from './create-advisor/create-advisor.component';
import { ApplicationsLinkComponent } from './shared/modal/applications-link/applications-link.component';
import {MatStepperModule, MatInputModule, MatIconModule, MatTabsModule, MatToolbarModule, MatExpansionModule} from '@angular/material'
//import { NewEditClientComponent } from './new-edit-client/new-edit-client.component';
import { NewEditClientComponent } from './client-edit/new-edit-client.component';
import { NavIllustrationComponent } from './shared/nav-illustration/nav-illustration.component';
import { NewIllustrationHcQuestionnaireComponent } from './new-illustration-hc-questionnaire/new-illustration-hc-questionnaire.component';
import { NewIllustrationLtcQuestionnaireComponent } from './new-illustration-ltc-questionnaire/new-illustration-ltc-questionnaire.component';
import { IllustrationHeaderComponent } from './shared/illustration-header/illustration-header.component';
import { HeaderCardComponent } from './shared/header-card/header-card.component';
import { HeaderTotalCardComponent } from './shared/header-total-card/header-total-card.component';
import { IllustratorBodyCardComponent } from './shared/illustrator-body-card/illustrator-body-card.component';
import { MmtBracketComponent } from './shared/modal/mmt-bracket/mmt-bracket.component';

import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import { NewIllustrationHcExpQuestionnaireComponent } from './new-illustration-hc-exp-questionnaire/new-illustration-hc-exp-questionnaire.component';
import { HealthcareExpressComponent } from './healthcare-express/healthcare-express.component';
import { CreateNewIllustrationComponent } from './create-new-illustration/create-new-illustration.component';
import { NewIllustrationCombQuestionnaireComponent } from './new-illustration-comb-questionnaire/new-illustration-comb-questionnaire.component';
import { NewIllustrationSsQuestionnaireComponent } from './new-illustration-ss-questionnaire/new-illustration-ss-questionnaire.component';
import { ResetHcQuestDataMsgComponent } from './shared/reset-hc-quest-data-msg/reset-hc-quest-data-msg.component';
import { MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { MessageComponent } from './shared/modal/message/message.component';
import { ChatBotComponent } from './shared/chat-bot/chat-bot.component'

import { InternalUserNWComponent } from './single-sign-on/nw/internal-users/internal-users.component';
import { ExternalUserNWComponent } from './single-sign-on/nw/external-users/external-users.component';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { RiskTolWizardComponent } from './shared/modal/risk-tol-wizard/risk-tol-wizard.component';
import { RiskRolAdvisorAgreementComponent } from './shared/modal/risk-rol-advisor-agreement/risk-rol-advisor-agreement.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { RetirementSuiteComponent } from './retirement-suite/retirement-suite.component';

// export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

export const OtherOptions: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  //touchGestures: 'auto',
  position: 'after',
  touchendHideDelay: 0,
  //disableTooltipInteractivity: false,
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    InternalUserNWComponent,
    ExternalUserNWComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    HomeComponent,
    SidebarComponent,
    SidebarClientComponent,
    SidebarClientEditComponent,
    PublicSidebarComponent,
    PublicHeaderComponent,
    TopnavComponent,
    ModalComponent,
    SnackBarComponent,
    TimeoutComponent,
    MetricRectangleComponent,
    AdvisorsComponent,
    ClientsComponent,
    SettingsComponent,
    AuthWrapperComponent,
    ApplicationsComponent,
    OrganizationsComponent,
    InfoCenterComponent,
    SupportComponent,
    SupportTicketsComponent,
    ProfileComponent,
    ReportsComponent,
    IllustrationsComponent,
    LegacyReportsComponent,
    CreateReportComponent,
    ViewReportsComponent,
    SocialSecurityComponent,
    MedicareMeansTestingComponent,
    MedicareMeansTestingComponentV2,
    HealthCareComponent,
    CombinedComponent,
    LongTermCareComponent,
    CombinedHealthCareLTCComponent,
    CreateReportSelectionComponent,
    MarketingMaterialComponent,
    ViewOrganizationsComponent,
    InfoIconComponent,
    NavCardComponent,
    SocialSecurityIllustrationCardComponent,
    SocialSecurityBenefitCardComponent,
    LoadingComponent,
    AdvisorBarComponent,
    BreadCrumbComponent,
    LeadsComponent,
    MetricsComponentV2,
    AdminComponent,
    CostProjectionDetailsComponent,
    AddCategoryComponent,
    UploadDocumentComponent,
    FundingSourceComponent,
    COLAComponent,
    PIAComponent,
    SubstantialEarningsComponent,
    AdjustDesiredClaimAgeComponent,
    AdjustRatesComponent,
    AdjustLongTermCareCost,
    MmtMessageComponent,
    BasicQuestionComponent,
    ProfileNotEligibleComponent,
    CostOfWaitingComponent,
    NewIllustrationsComponent,
    NewIllustrationOptionsComponent,
    CreateClientComponent,
    NewAddClientComponent,
    CreateAdvisorComponent,
    ApplicationsLinkComponent,
    NewEditClientComponent,
    NavIllustrationComponent,
    NewIllustrationHcQuestionnaireComponent,
    NewIllustrationLtcQuestionnaireComponent,
    IllustrationHeaderComponent,
    HeaderCardComponent,
    HeaderTotalCardComponent,
    IllustratorBodyCardComponent,
    MmtBracketComponent,
    NewIllustrationHcExpQuestionnaireComponent,
    HealthcareExpressComponent,
    CreateNewIllustrationComponent,
    NewIllustrationCombQuestionnaireComponent,
    NewIllustrationSsQuestionnaireComponent,
    ResetHcQuestDataMsgComponent,
    MessageComponent,
    ChatBotComponent,
    RiskTolWizardComponent,
    RiskRolAdvisorAgreementComponent,
    IntegrationsComponent,
    RetirementSuiteComponent
  ],
  entryComponents: [
    FundingSourceComponent,
    COLAComponent,
    PIAComponent,
    SubstantialEarningsComponent,
    AdjustDesiredClaimAgeComponent,
    AdjustRatesComponent,
    RiskTolWizardComponent,
    RiskRolAdvisorAgreementComponent,
    AdjustLongTermCareCost,
    MmtMessageComponent,
    BasicQuestionComponent,
    ProfileNotEligibleComponent,
    CostProjectionDetailsComponent,
    AddCategoryComponent,
    SupportComponent,
    ProfileComponent,
    UploadDocumentComponent,
    CostOfWaitingComponent,
    ApplicationsLinkComponent,
    MmtBracketComponent,
    ResetHcQuestDataMsgComponent,
    MessageComponent,
    ChatBotComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    NgxTwitterTimelineModule,
    HttpClientModule,
    AppRoutingModule,
    NgxChartsModule,
    BrowserAnimationsModule,    
    MatButtonModule, MatButtonToggleModule, MatTooltipModule,MatOptionModule,MatSelectModule,MatDatepickerModule,MatRadioModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    /* NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule, */
    MatDialogModule,
    MatCardModule,
    // FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    MyDatePickerModule,
    DragAndDropModule,
    Ng5SliderModule,
    CommonModule,
    MatSliderModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    MatToolbarModule,
    MatStepperModule,
    MatExpansionModule,
    CurrencyMaskModule
    // NgxMaskModule.forRoot(),
  ],
  providers: [
    AuthService,
    AuthGuard,
    ModalService,
    SnackBarService,
    AdvisorBarService,
    UserService,
    SidebarService,
    GlobalService,
    OrganizationService,
    PagerService,
    MenuService,
    LoadingService,
    ClientService,
    HttpClient,
    DecimalPipe,
    CurrencyPipe,
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: OtherOptions},
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6LeOczsUAAAAAOaCRf0YOQ8l7oIemk08k8ccmYBe', //same key used for hvsfinancial.com, bamria.com and healthycapital.com
      } as RecaptchaSettings,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  /* constructor(private loadingService: LoadingService){
    this.loadingService.isLoading(true);

  } */
}
